export default __webpack_public_path__ + "static/media/NASA_07.743958a5.png";